<template>
  <modal
    name="modal--switch-stores"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="300"
    :height="'auto'"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="w-full">
        <div class="text-center text-4xl mb-1 font-extralight tracking-tight">
          Switch Stores
        </div>
        <div class="text-center text-2xl mb-6 font-extralight tracking-tight">
          Are you sure?
        </div>

        <div class="flex flex-row justify-between mt-3">
          <div class="button" @click="hideModal">
            Cancel
          </div>
          <div class="button" @click="confirm">
            Confirm
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ModalSwitchStores',
  data() {
    return {
      action: ''
    }
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    ...mapActions(['switchStores']),
    beforeOpen(event) {
      if (event.params && event.params.id) this.action = event.params.id
      this.setFabVisible(false)
    },
    beforeClose() {
      this.setFabVisible(true)
    },
    hideModal() {
      this.$modal.hide('modal--switch-stores')
    },
    async confirm() {
      this.$modal.show('loading')
      this.hideModal()
      await this.switchStores(this.action).then(() => {
        console.log('switching stores')
        this.$router.currentRoute.name !== 'dashboard' &&
          this.$router.replace({ name: 'dashboard' }) // push?
        console.log(this.$router.currentRoute.name)
      })
    }
  }
}
</script>
